/*
 * assets/js/src/nahoru.js — tlačítko „zpět nahoru" v patičce.
 *
 * ZÁKLAD JE BEZ SKRIPTU. V patičce je `<a class="tonahoru" href="#nahoru">`
 * a `#nahoru` je prázdný `<span>` NAD hlavičkou, takže skok nahoru funguje
 * i s vypnutým JS (na `<header>` kotva nesmí: je `sticky`, tedy pořád
 * vidět, a prohlížeč by neměl kam rolovat) —
 * to je požadavek majitele ze 17. 9., ne hezká vlastnost navíc. Plynulost
 * zajišťuje `scroll-behavior: smooth` v CSS, které samo respektuje
 * `prefers-reduced-motion`.
 *
 * Modul přidává dvě věci, které samotný odkaz neumí:
 *   1. NEZŮSTANE HASH V ADRESE. Bez toho by po klepnutí URL končila
 *      `#nahoru` a sdílený odkaz by cizí stránku otevřel odrolovanou.
 *   2. FOKUS NA ZAČÁTEK. Prohlížeč ho po programovém scrollu nepřesune
 *      sám, takže klávesnice i čtečka zůstanou dole v patičce.
 *
 * Když kotva chybí, modul NIC NEDĚLÁ a odkaz se chová nativně. Je to
 * záměrně tichá degradace: rozbít funkční odkaz kvůli vylepšení by bylo
 * horší než vylepšení vynechat.
 */

export function init() {
	const odkazy = [...document.querySelectorAll('a.tonahoru[href="#nahoru"]')];
	if (!odkazy.length) return 0;

	const cil = document.getElementById('nahoru');
	if (!cil) return 0;

	const klidnyRezim = () =>
		window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	let pocet = 0;
	for (const odkaz of odkazy) {
		odkaz.addEventListener('click', (e) => {
			e.preventDefault();
			window.scrollTo({ top: 0, behavior: klidnyRezim() ? 'auto' : 'smooth' });
			// `preventScroll` schválně: scroll už běží výš a fokus by ho utnul.
			// `preventScroll` neumí Safari pod 15 — tam fokus dojede sám.
			try {
				cil.focus({ preventScroll: true });
			} catch {
				cil.focus();
			}
		});
		pocet += 1;
	}
	return pocet;
}
